import { useHistory } from 'react-router-dom'

import { Auth } from '@scouts/auth'
import { ButtonLink, Line } from '@scouts/ui'

import { PATH_LOGIN } from '@/constants'

const Footer = () => {
    const history = useHistory()

    return <ButtonLink onClick={() => history.push(PATH_LOGIN)}>Atrás</ButtonLink>
}

export const ResetPassword = () => {
    return (
        <Auth.LockscreenLayout title="Restaura tu contraseña" footer={<Footer />}>
            <Line textAlign="center">Te enviaremos un e-mail con los pasos para recuperar tu contraseña</Line>
            <Auth.ResetPasswordForm />
        </Auth.LockscreenLayout>
    )
}
